export function getFacebookShareLink() {
    return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`;
}

export function getTwitterShareLink(jobAdTitle: string) {
    const query = new URLSearchParams({
        original_referer: window.location.href,
        text: jobAdTitle,
        url: window.location.href,
    });
    return `https://twitter.com/intent/tweet?${query}`;
}

export function getLinkedinShareLink() {
    return `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(window.location.href)}`;
}
